import React, { useEffect } from "react";
import { useTrapSkuStore } from "./stores/trapSkuStore";
import TrapSkuHeader from "./components/TrapSkuHeader/TrapSkuHeader";
import TrapSkuTable from "./components/TrapSkuTable/TrapSkuTable";
import { Loading, PaginationControls, PageHistory, PermissionWrapper } from "components";
import { trapHistoryConfig } from "./utils/trapHistoryConfig";

// Типи записів історії, які показуємо на цій сторінці
const HISTORY_SUBJECTS = ["trap_price", "trap_category", "trap_presence"];

// Головний компонент сторінки "Товари ловушок"
const TrapSkuPage = () => {
  // Отримуємо необхідні дані та дії зі стору
  const isLoading = useTrapSkuStore((state) => state.isLoading);
  const filters = useTrapSkuStore((state) => state.filters);
  const totalCount = useTrapSkuStore((state) => state.totalCount);
  const setPage = useTrapSkuStore((state) => state.setPage);
  const init = useTrapSkuStore((state) => state.init);

  // Ефект для початкової ініціалізації при першому завантаженні сторінки
  useEffect(() => {
    init();
  }, [init]);

  return (
    <section id="trapskupage">
      <PermissionWrapper requiredPermission="activity_log:view">
        <PageHistory subjects={HISTORY_SUBJECTS} config={trapHistoryConfig} />
      </PermissionWrapper>
      <div className="page-container">
        <TrapSkuHeader />

        {isLoading ? (
          <Loading />
        ) : (
          <>
            <TrapSkuTable />
            <PaginationControls
              page={filters.page}
              totalPages={Math.ceil(totalCount / filters.page_size) || 1}
              onPageChange={(page) => setPage(page)}
            />
          </>
        )}
      </div>
    </section>
  );
};

export default TrapSkuPage;
